import React, { useEffect } from 'react';
import cn from 'classnames';
import Form, { useForm } from 'components/Form';
import {
  Title,
  SectionWrapper,
} from 'views/pages/ClientDetail/components/Elements';
import ButtonActions from 'views/pages/ClientDetail/components/ButtonActions';
import OnlinePortal from 'views/pages/ClientDetail/components/OnlinePortal';
import Profile from './Profile';
import FilesSection from './FilesSection';
import { getInitialValues } from '../../tabUtils/irp';
import { filingTransformData } from '../../tabUtils/index';
import classes from './IRP.module.scss';

const IRP = ({
  className,
  wrapperId,
  handleSubmit,
  isEdit,
  setIsEdit,
  isFormChange,
  loading,
  openWarningModal,
  data,
  setIsFormChanged,
  onFormChange,
  years,
  handleYearSubmit,
}) => {
  const transformData = filingTransformData(data);
  const [form] = useForm();
  const initialValues = getInitialValues(data);
  useEffect(() => {
    if (isEdit) {
      setIsFormChanged(false);
      if (form) {
        form.resetFields();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

  return (
    <SectionWrapper className={cn(classes.wrapper, className)} id={wrapperId}>
      <Form
        validateMessages={''}
        onFinish={values => {
          handleSubmit(values, form);
        }}
        initialValues={initialValues}
        form={form}
        onValuesChange={() => {
          setIsFormChanged(true);
          onFormChange();
        }}
      >
        <div>
          <Title text="IRP - International Registration Plan">
            <ButtonActions
              setIsEdit={setIsEdit}
              isEdit={isEdit}
              form={form}
              isFormChanged={isFormChange}
              loading={loading}
              className={classes.buttonActions}
              onSubmit={values => {
                handleSubmit(values, form);
              }}
              openWarningModal={openWarningModal}
            />
          </Title>
          <OnlinePortal
            title="IRP Online Portal"
            form={form}
            isEdit={isEdit}
            data={transformData}
            fields={[
              {
                name: 'username',
                label: 'Username',
                type: 'value',
                key: 'username',
              },
              {
                name: 'password',
                label: 'Password',
                type: 'value',
                key: 'password',
              },
            ]}
          />
          <Profile isEdit={isEdit} form={form} data={transformData} />
          <Title text="IRP - Registrations By Year" />
          <FilesSection
            years={years}
            form={form}
            data={transformData}
            handleYearSubmit={handleYearSubmit}
            initialValues={initialValues}
          />
        </div>
      </Form>
    </SectionWrapper>
  );
};

export default IRP;
